webpackJsonp([17],{

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);

var initInfluencerShareLink = __webpack_require__(17);

var BANNER_TARGET_CLASS = '.js-cpl-banner';
var ITEM_CLASS = '.card--cfy';
var ACTIVE_CLASS = 'card-cfy--active';
var CPL_ID_PARAM = 'cplid';
$(function () {
  initInfluencerShareLink();
  var urlParams = new URLSearchParams(window.location.search);
  var cplId = urlParams.get(CPL_ID_PARAM);
  $(ITEM_CLASS, $(BANNER_TARGET_CLASS)).each(function (i, el) {
    var $card = $(el);
    var $anchor = $('a', $card);

    if ($anchor.length) {
      var href = $anchor.attr('href');
      var hrefParts = href ? href.split('?') : [];
      var anchorUrlParams = new URLSearchParams(hrefParts.length === 2 ? '?' + hrefParts[1] : '');
      var anchorCplId = anchorUrlParams.get(CPL_ID_PARAM);

      if (anchorCplId === cplId) {
        $card.addClass(ACTIVE_CLASS);
      }
    }
  });
});

/***/ })

},[183]);


// WEBPACK FOOTER //
// dist/cpl.js